import React from 'react';
import Tarjeta from './componenteshome/tarjeta';
import FooterMenu from './componenteshome/footer';
import MenuEscritorio from './componenteshome/MenuEscritorio';
import '../css/cssgeneral.css'; 


function Home() {

  return (<div><Tarjeta/><FooterMenu/><MenuEscritorio/></div>);
}

export default Home;
